import * as firebase from "firebase";

const config = {
  apiKey: "AIzaSyCCHyHBJ-tgOVdr0fjFZ2YmSm5V7RcIF-w",
  authDomain: "recallify-words.firebaseapp.com",
  databaseURL: "https://recallify-words.firebaseio.com",
  projectId: "recallify-words",
  storageBucket: "",
  messagingSenderId: "884773848997"
};
firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { firebase, googleAuthProvider, database as default };
